const appendScript = ({ targetElement, async, src, id, onScriptLoad }) => {
  const document = window.document
  if (document.querySelector(`#${id}`) === null) {
    let scriptTag = document.createElement("script")
    scriptTag.id = id
    scriptTag.async = async
    scriptTag.src = src
    targetElement.appendChild(scriptTag)
    scriptTag.onload = () => {
      onScriptLoad && onScriptLoad()
    }
  }
}

export default appendScript
